import { makeObservable, observable, action, runInAction } from "mobx";
import axios from "../config/axios";

class LicensesStore {
  licenses = [];
  specificLicense = {};

  isLoadingLicenses = false;
  isLoadingSpecificLicense = false;

  constructor() {
    makeObservable(this, {
      licenses: observable.ref,
      isLoadingLicenses: observable.ref,
      specificLicense: observable.ref,
      isLoadingSpecificLicense: observable.ref,

      getLicenses: action,
      getSpecificLicense: action,
      createLicense: action,
      deleteLicense: action,
      updateLicense: action,
    });
  }

  getLicenses = () => {
    runInAction(() => {
      this.isLoadingLicenses = true;
    });
    axios
      .get("api/licenses/")
      .then(({ data }) => {
        runInAction(() => {
          this.licenses = data;
          this.isLoadingLicenses = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingLicenses = false;
        });
      });
  };

  getSpecificLicense = (id) => {
    runInAction(() => {
      this.isLoadingSpecificLicense = true;
    });
    axios
      .get(`api/licenses/${id}/`)
      .then(({ data }) => {
        runInAction(() => {
          this.specificLicense = data;
          this.isLoadingSpecificLicense = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingSpecificLicense = false;
        });
      });
  };

  createLicense = ({ payload, callback }) => {
    runInAction(() => {
      this.isLoadingLicenses = true;
    });
    axios
      .post("api/licenses/", payload)
      .then(({ data }) => {
        runInAction(() => {
          const newLicenses = [...this.licenses, data];
          this.licenses = newLicenses;
          callback && callback();
          this.isLoadingLicenses = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingLicenses = false;
        });
      });
  };

  deleteLicense = ({ id, callback }) => {
    runInAction(() => {
      this.isLoadingLicenses = true;
    });
    axios
      .delete(`api/licenses/${id}/`)
      .then(() => {
        runInAction(() => {
          const newLicenses = this.licenses.filter((el) => el.id !== id);
          this.licenses = newLicenses;
          callback && callback();
          this.isLoadingLicenses = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingLicenses = false;
        });
      });
  };

  updateLicense = ({ id, payload }) => {
    runInAction(() => {
      this.isLoadingSpecificLicense = true;
    });
    axios
      .put(`api/licenses/${id}/`, payload)
      .then(({ data }) => {
        runInAction(() => {
          this.specificLicense = data;
          this.isLoadingSpecificLicense = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingSpecificLicense = false;
        });
      });
  };
}

export default new LicensesStore();
